import {
  always,
  compose,
  converge,
  equals,
  flatten,
  head,
  isNil,
  map,
  path,
  pathOr,
  propOr,
  split,
} from 'ramda';
import { resolver } from '../util';
import { ApplicationModel, queryApplications, IdmuserinfoModel } from '../../models';

const extractDomainFromApplicationModel = pathOr('', ['fields', 'domain']);

const extractTeamIdFromRollString = compose(
  head,
  split(':'),
);

const getTeamIdsFromUserModel = compose(
  map(extractTeamIdFromRollString),
  pathOr([], ['auminfo', 'roles']),
);

export const getDomainsForUserId = async (userId) => {
  const Idmuserinfo = IdmuserinfoModel();
  const Application = ApplicationModel();

  const userModel = await Idmuserinfo.findUserByUserID(userId);
  const teamIds = getTeamIdsFromUserModel(userModel);
  const ownerIds = [userId, ...teamIds];

  const ownedApplicationResults = await Promise.all(
    map(Application.findApplicationByOwnerId, ownerIds),
  );
  const ownedApplications = flatten(ownedApplicationResults);
  const ownedDomains = map(
    extractDomainFromApplicationModel,
    ownedApplications,
  );

  return ownedDomains;
};

export const getAllDomains = async () => {
  const Application = ApplicationModel();
  const applications2 = await Application.findApplications('', 0, 1000, 'allApplications');
  const domains = map(extractDomainFromApplicationModel, applications2);
  return domains;
};

const getDomains = resolver.authenticatedResolver.createResolver(
  async (root, args, { user }) => {
    const userId = propOr('*', 'user_id', user);

    return equals('*', userId) ? getAllDomains() : getDomainsForUserId(userId);
  },
);

const checkDomainAvailable = resolver.compose(
  isNil,
  queryApplications('findApplicationByDomain'),
  resolver.argProp('domain'),
);

const searchDomains = resolver.compose(
  map(path(['fields', 'domain'])),
  converge(queryApplications('findApplications'),
    [
      resolver.argProp('search'),
      always(0),
      always(30),
    ]),
);

export default {
  Query: {
    getDomains,
    domainAvailable: checkDomainAvailable,
    searchDomains,
  },
};
